import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getInterface(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/affiliate_system_interfaces/`,
    oauthTokenHeader
  );
}

function getDestinationTables(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/unifier_destination_tables/`,
    oauthTokenHeader
  );
}

function getMapsData(oauthTokenHeader: string, interfaceID: any) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/unifier_maps/?backend_interface_id=${interfaceID}`,
    oauthTokenHeader
  );
}

function getMapDetails(oauthTokenHeader: string, mapID: string) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/unifier_maps_details/?map_id=${mapID}`,
    oauthTokenHeader
  );
}

function getFieldResource(oauthTokenHeader: string, fieldID: string) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/unifier_field_resource/?field_id=${fieldID}`,
    oauthTokenHeader
  );
}

function getAllCalculationTypesMaps(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/calculation_types/`,
    oauthTokenHeader
  );
}

function getUnifierUniqueDefinitionMaps(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/data_unique_definitions/`,
    oauthTokenHeader
  );
}
function createMap(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/data_collection/unifier_map_configuration/`,
    data,
    oauthTokenHeader
  );
}
function editMap(oauthTokenHeader: string, id: any, data: any) {
  return fetchWrapper.put(
    `${apiUrl}/data_collection/unifier_map_configuration/${id}/`,
    data,
    oauthTokenHeader
  );
}

function validateSourceField(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/data_collection/validate_source_field/`,
    data,
    oauthTokenHeader
  );
}
function unifierRawTableData(oauthTokenHeader: any, id: any) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/unifier_raw_table_data/?table_id=${id}`,
    oauthTokenHeader
  );
}
export const MapsService = {
  getInterface,
  getDestinationTables,
  getMapsData,
  getMapDetails,
  getFieldResource,
  getAllCalculationTypesMaps,
  getUnifierUniqueDefinitionMaps,
  createMap,
  editMap,
  validateSourceField,
  unifierRawTableData,
};
